import {keyframes} from '@mui/system';

// Color-aware ring pulse. The two custom properties below are set per-color
// in the MuiButton / MuiChip theme customizations so the pulse adopts the
// component's palette (info → blue, warning → orange, etc).
//
// Falls back to blue so any consumer applying className="pulse" outside of
// the themed components still gets a sensible default.
export const pulse = keyframes`
    0% { box-shadow: 0 0 0 0 var(--pulse-color, hsla(210, 98%, 48%, 0.5)); }
    70% { box-shadow: 0 0 0 8px var(--pulse-color-fade, hsla(210, 98%, 48%, 0)); }
    100% { box-shadow: 0 0 0 0 var(--pulse-color-fade, hsla(210, 98%, 48%, 0)); }
`;

// Back-compat: existing callsites import {bluePulse}.
export const bluePulse = pulse;

export const pulseSx = {
    animation: `${pulse} 1.8s ease-in-out infinite`
};
